import {Directive, ElementRef} from '@angular/core';
import {UserPreferencesService} from '../service/user-preferences.service';
@Directive({
  selector: '[appTitle]'
})
export class TitleDirective {
  constructor(el: ElementRef, private userPreferencesService: UserPreferencesService) {
    el.nativeElement.style.color = this.userPreferencesService.getTitleTextColor();
  }
}
